const tasksPage = {
  en: {
    tasks: {
      title: 'Tasks',
      showOnlyUnresolvedCheckbox: 'Show only unresolved',
      searchPlaceholder: 'Start typing patient name...',
      error: 'Something went wrong',
      showLessBtn: 'Show less',
      showMoreBtn: 'Show more',
      filterTitle: 'Filter',
      noMoreData: 'No more data',
      asapStatus: 'ASAP',
      overdue: 'Overdue',
      table: {
        dateHeader: 'Due date',
        patientAndLocationHeader: 'Patient & location',
        tasksHeader: 'Tasks',
        statusHeader: 'Current status',
        ctaHeader: '',
        tasksAndResidentHeader: 'Tasks & patient',
      },
      reminderLabel: {
        labOrder: 'Lab order',
        imageOrder: 'Imaging order',
        callToLocation: 'Call to location',
        followUpVisit: 'Follow-up visit',
        callToFamily: 'Call to family',
        noType: 'No type',
      },
      filters: {
        communityTitle: 'Locations',
      },
      taskStatuses: {
        resolved: 'Resolved',
        unableToConnect: 'Unable to connect',
        canceled: 'Canceled',
        ordered: 'Ordered',
        scheduled: 'Scheduled',
        connected: 'Connected no resolution',
        collected: 'Collected',
      },
      taskType: {
        labOrder: 'Labs',
        imageOrder: 'Imaging',
        callToLocation: 'Call to locations',
        followUpVisit: 'Follow-up',
        callToFamily: 'Call to family',
      },
    },
  },
}
export default tasksPage
